export function getMyClasterContentLayout() {
  return ymaps.templateLayoutFactory.createClass('<div style="color: #FFFFFF; font-weight: bold; font-size: 18px;">{{ properties.geoObjects.length }}</div>');
}

export function getClusterIcons() {
  return [{
    href: '/images/checkout/claster-small.svg',
    size: [40, 40],
    offset: [-20, -20],
    shape: {
      type: 'Circle',
      coordinates: [0, 0],
      radius: 20
    }
  }, {
    href: '/images/checkout/claster-middle.svg',
    size: [48, 48],
    offset: [-24, -24],
    shape: {
      type: 'Circle',
      coordinates: [0, 0],
      radius: 24
    }
  }];
}

export const clusterNumbers = [10];
